import { render, staticRenderFns } from "./add-partner-to-orphan-list.vue?vue&type=template&id=d5174406&"
import script from "./add-partner-to-orphan-list.vue?vue&type=script&lang=js&"
export * from "./add-partner-to-orphan-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports